import './Header.scss'
import {Container, OverlayTrigger, Popover} from "react-bootstrap";
import {GoInfo} from "react-icons/go";
import {FiChevronDown, FiChevronUp} from "react-icons/fi";
import {useContext, useEffect, useState} from "react";
import AppContext from "../AppContext";
import PendingOrderNotice from "./PendingOrderNotice";
import {Course} from "../models/Course";
import API, {HandleError} from "../API";
import {User} from "../models/User";
import {useSnackbar} from "notistack";
import {courseIcon, localeIcon, localeName} from "../Tools";
import {useTranslation} from "react-i18next";
import {Trans} from "react-i18next/icu.macro";

export default function Header() {
    const { t, i18n } = useTranslation();
    const app = useContext(AppContext)
    const { enqueueSnackbar } = useSnackbar()
    const [coursePickerShown, setCoursePickerShown] = useState(false)
    const [localePickerShown, setLocalePickerShown] = useState(false)
    const [currentCourse, setCurrentCourse] = useState(null)
    useEffect(() => {
        app.ui.courses.forEach((course, idx) => {
            if(course.ID === app.user?.current_course) {
                setCurrentCourse(new Course(course))
                return false
            }
        })
    }, [app.ui.courses, app.user?.current_course])
    const tooltipPoints = (
        <Popover id="popover-points-info">
            <Popover.Header as="h3">{t('points.name')}</Popover.Header>
            <Popover.Body>
                <p className="text-muted">
                    {t('points.text1')}
                </p>
                <strong>{t('points.pointsEarned')}</strong><br />
                <p>
                    {t('thisWeek')}: <strong>{app.user?.points}</strong> Pts<br />
                    {t('allTime')}: <strong>{app.user?.all_points}</strong> Pts
               </p>
                <p className="alert alert-info mb-0">
                    <Trans i18nKey="points.text2" />
                </p>
                {/*<a href="#">Meer over punten & beloningen</a>*/}
            </Popover.Body>
        </Popover>
    )

    const toggleCoursePicker = () => {
        setCoursePickerShown(!coursePickerShown)
    }
    const toggleLocalePicker = () => {
        setLocalePickerShown(!localePickerShown)
    }

    const changeCourse = async (course_id) => {
        setCoursePickerShown(false)
        app.startLoading()
        try {
            const res = await API({
                method: 'POST',
                url: `/account/${app.user?.ID}/course/${course_id}`,
                headers: {
                    'Authorization': `Bearer ${app.token}`,
                },
                data: {}
            })

            if (res.status < 200 || res.status > 299)
                throw res.data;

            app.set({
                user: new User(res.data.me),
                ui: {...app.ui, ...res.data.ui},
                loading: false
            })
            // app.setUI(res.data.ui)
            // app.stopLoading()
            // app.setUser(new User(res.data.me))

        }
        catch(e) {
            app.stopLoading()
            HandleError(e, 'Error', enqueueSnackbar, app.logout);
        }
    }

    const changeLocale = async (locale) => {
        setLocalePickerShown(false)
        app.startLoading()
        try {
            const res = await API({
                method: 'POST',
                url: `/account/${app.user?.ID}/locale/${locale}`,
                headers: {
                    'Authorization': `Bearer ${app.token}`,
                },
                data: {}
            })

            if (res.status < 200 || res.status > 299)
                throw res.data;

            window.location.reload();
            // app.set({
            //     user: new User(res.data.me),
            //     ui: {...app.ui, ...res.data.ui},
            //     loading: false
            // })

        }
        catch(e) {
            app.stopLoading()
            HandleError(e, 'Error', enqueueSnackbar, app.logout);
        }
    }

    return <>
        <header id="header">
            <div className="header-user-info">
                <strong className="header-user">{app.user?.first_name}</strong>
                <div className="header-progress">
                    <span>{app.user?.points} Pts</span>
                    <OverlayTrigger defaultShow={false} trigger={['hover', 'focus', 'click']} placement="right" overlay={tooltipPoints} delay={300}>
                        <span style={{ paddingRight: 10 }} className="points-info-trigger"><GoInfo /></span>
                    </OverlayTrigger>
                </div>
            </div>
            {app.user?.multilingual != 1 &&
            <div className={"header-course " + (coursePickerShown ? 'picker-shown' : '')}>
                <span onClick={toggleCoursePicker}>{courseIcon(currentCourse?.ID)} {currentCourse?.name} {coursePickerShown ? <FiChevronUp /> : <FiChevronDown />}</span>
                <ul className="header-courses-dropdown">
                    {app.ui.courses.map(function(course, idx) {
                        if(course.ID === currentCourse?.ID)
                            return null
                        return <li key={'course-' + idx} onClick={() => changeCourse(course.ID)}>{courseIcon(course.ID)} {course.name}</li>
                    })}
                </ul>
            </div>}
            {app.user?.multilingual == 1 &&
            <div className={"header-locale " + (localePickerShown ? 'picker-shown' : '')}>
                <span onClick={toggleLocalePicker}>{localeIcon(app.ui.locale)} {localeName(app.ui.locale)} {localePickerShown ? <FiChevronUp /> : <FiChevronDown />}</span>
                <ul className="header-locale-dropdown">
                    {['nl', 'en'].map(function(locale, idx) {
                        if(locale === app.ui.locale)
                            return null
                        return <li key={'locale-' + idx} onClick={() => changeLocale(locale)}>{localeIcon(locale)} {localeName(locale)}</li>
                    })}
                </ul>
            </div>}
        </header>
        <section id="notices">
            <Container fluid={true}>
                <PendingOrderNotice />
            </Container>
        </section>
    </>
}